$(document).ready(function() {

	//initialize the lightbox
	$('.fancybox-media').fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		helpers : {
			media : {}
		}
	});


	//set the items per page links
	$('#top_items_per_page_selector').change(function(){
		alter_videos_view($(this).val());
	});

	$('#bottom_items_per_page_selector').change(function(){
		alter_videos_view($(this).val());
	});

	//set the filtering links 
	$('.filtering_options_list').change(function(){
			if($(this).val()=='all'){
				//display the loader
	        	showLoader();
				window.location.href = base_url+"/videos";
			}else{
				//display the loader
	        	showLoader();
				window.location.href = base_url+"/videos/"+$(this).val();
			}
		});

});


function alter_videos_view(value)
{
	$.ajax({
        type:       'POST',
        url:        base_url+'/videos/change_number_of_gallery_videos_per_page/'+value,
        dataType:   'json',
        beforeSend : function (){
        	//display the loader
        	showLoader();
		},
        success:  function(json){
            	if(json.status=='success'){
        			//reload the page
        			loc = window.location.href.split('?')[0];
        			window.location.href = loc;
    		}
   	 	}
	});
}